"use strict";
/**
 * View more at: https://docs.google.com/spreadsheets/d/1jUyFmVgt5u0wluGcONGjBgIj0WBLQ2c91mJ7Je9bD2M/edit#gid=0
 * Listing all of the supported schemas
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RacingLobbyType = exports.EventId = void 0;
var EventId;
(function (EventId) {
    EventId["ClickButton"] = "web.buttonClickEvent";
    EventId["Buying"] = "web.buyingEvent";
    EventId["Custom"] = "web.customEvent";
    EventId["Error"] = "web.errorEvent";
    EventId["HeartBeat"] = "web.heartBeat";
    EventId["Renting"] = "web.rentingEvent";
    EventId["ScreenView"] = "web.screenViewEvent";
    EventId["SigningTransaction"] = "web.signingEvent";
    EventId["Breeding"] = "web.breedingEvent";
    EventId["FindMatch"] = "web.findMatchEvent";
    EventId["StartMatch"] = "web.startMatchEvent";
    EventId["SwapEvent"] = "web.swapEvent";
})(EventId = exports.EventId || (exports.EventId = {}));
var RacingLobbyType;
(function (RacingLobbyType) {
    RacingLobbyType["Fire"] = "fire";
    RacingLobbyType["Lightning"] = "lightning";
    RacingLobbyType["Water"] = "water";
    RacingLobbyType["Wind"] = "wind";
})(RacingLobbyType = exports.RacingLobbyType || (exports.RacingLobbyType = {}));
